var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar'),_c('breadcrumbs'),_c('div',{staticClass:"container"},[_c('transport-vehicle')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }